import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Swiper from 'react-id-swiper';
import { Element } from 'react-scroll';

import { TOUR_PAGE_NAV } from 'config';
import {
  mapStateToProps,
} from 'utilities';
import {
  ActivityCard,
  Slide,
  ActivityModal,
} from 'components';

const GALLERY_OPTIONS = {
  containerClass: 'c-addon-slider__container',
  slidesPerView: 3,
  spaceBetween: 10,
  speed: 500,
  roundLengths: true,
  simulateTouch: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // when window width is <= 767px
    767: {
      slidesPerView: 'auto',
      spaceBetween: 5,
    },
  },
};


class AddonsUpgrades extends PureComponent {
  /**
   * Constructor
   */
  constructor(props) {
    super(props);

    this.state = {
      modal: {},
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  /**
   * Handle open
   */
  handleOpen(id) {
    this.setState(prevState => ({
      modal: {
        ...prevState,
        [id]: true,
      },
    }));
  }


  /**
   * Handle close
   */
  handleClose(id) {
    this.setState(prevState => ({
      modal: {
        ...prevState,
        [id]: false,
      },
    }));
  }

  /**
   * Render
   */
  render() {
    const {
      addons,
      upgrades,
      essentials,
      images,
    } = this.props;
    const { modal } = this.state;

    if (!addons.length && !upgrades.length) return null;

    return (
      <Element
        name={TOUR_PAGE_NAV.ADDONS_UPGRADES.NAME}
        className="l-tour-addons-upgrades l-tour-page__section"
      >
        <h3 className="c-heading c-heading--h3">ENHANCE YOUR TRIP WITH ADD-ON ACTIVITIES AND UPGRADES</h3>
        <p>
          Your tour includes all the essentials but you can add extra wow-factor to your tour by adding on the activities and accommodation upgrades that suit you best.
        </p>

        {!!addons.length && (
          <div className="c-addon-slider">
            <p>Optional activities you can book whilst on the tour. Your driver will book this in for you and you can pay the activity operator directly.</p>

            <div className={`${GALLERY_OPTIONS.containerClass}-wrapper`}>
              <Swiper {...GALLERY_OPTIONS}>
                {addons.map(item => (
                  <Slide key={item.id}>
                    {/* eslint-disable-next-line */}
                    <div onClick={() => this.handleOpen(item.id)}>
                      <ActivityCard
                        data={item}
                        showFavourite={false}
                      />
                    </div>
                    <ActivityModal
                      activity={item}
                      images={images}
                      open={!!modal[item.id]}
                      handleClose={() => {
                        this.handleClose(item.id);
                      }}
                    />
                  </Slide>
                ))}
              </Swiper>
            </div>
          </div>
        )}

        {(!!upgrades.length || !!essentials.length) && (
          <div className="c-addon-slider">
            <p>Optional accommodation upgrades and add-ons for this trip:</p>

            <div className={`${GALLERY_OPTIONS.containerClass}-wrapper`}>
              <Swiper {...GALLERY_OPTIONS}>
                {upgrades.map(item => (
                  <Slide key={item.id}>
                    {/* eslint-disable-next-line */}
                    <div onClick={() => this.handleOpen(item.id)}>
                      <ActivityCard
                        data={item}
                        showLocation={false}
                        showFavourite={false}
                      />
                    </div>

                    <ActivityModal
                      activity={item}
                      images={images}
                      open={!!modal[item.id]}
                      handleClose={() => {
                        this.handleClose(item.id);
                      }}
                    />
                  </Slide>
                ))}
                {essentials.map(item => (
                  <Slide key={item.id}>
                    {/* eslint-disable-next-line */}
                    <div onClick={() => this.handleOpen(item.id)}>
                      <ActivityCard
                        data={item}
                        showLocation={false}
                        showFavourite={false}
                      />
                    </div>

                    <ActivityModal
                      activity={item}
                      images={images}
                      showLocation={false}
                      showFavorite={false}
                      open={!!modal[item.id]}
                      handleClose={() => {
                        this.handleClose(item.id);
                      }}
                    />
                  </Slide>
                ))}
              </Swiper>
            </div>
          </div>
        )}
      </Element>
    );
  }
}

AddonsUpgrades.propTypes = {
  addons: PropTypes.array,
  upgrades: PropTypes.array,
  essentials: PropTypes.array,
  images: PropTypes.array,
  user: PropTypes.object.isRequired,
};

AddonsUpgrades.defaultProps = {
  addons: [],
  upgrades: [],
  essentials: [],
  images: [],
};

export default connect(mapStateToProps)(AddonsUpgrades);
